/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios, { CancelTokenSource } from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ApiResponse | undefined,
  (requestParams: vp.WorkflowUpdateRequest) => void,
  (requestParams: vp.WorkflowUpdateRequest) => Promise<vp.ApiResponse>,
  () => void,
];

function usePostUpdateWorkflow({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.WorkflowUpdateRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.WorkflowUpdateRequest, cancelTokenSource: CancelTokenSource) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postUpdateWorkflow(requestParams, cancelTokenSource);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params, source);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.WorkflowUpdateRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    async (requestParams: vp.WorkflowUpdateRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postUpdateWorkflow(requestParams, source);
      setDataFetchingInfo(false);
      return res;
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostUpdateWorkflow);
